import type { ComponentProps } from 'react'

import type { VariantProps } from '@joyful/utils'
import { tv } from '@joyful/utils'

const notificationDotVariants = tv({
  base: 'rounded-full',

  defaultVariants: {
    colorVariant: 'subtle',
    placement: 'corner',
    size: 'sm',
  },

  variants: {
    colorVariant: {
      brand: 'bg-tremor-brand',
      subtle: 'bg-tremor-brand-subtle',
    },

    placement: {
      corner: 'ring-tremor-background absolute -top-2 -right-2 ring-2',
      inline: 'static shrink-0 ring-0',
    },

    size: {
      md: 'size-2',
      sm: 'size-1.5',
    },
  },
})

export interface NotificationDotProps
  extends
    Omit<ComponentProps<'span'>, 'className'>,
    VariantProps<typeof notificationDotVariants> {}

export function NotificationDot({
  colorVariant,
  placement,
  size,
  ...props
}: NotificationDotProps) {
  return (
    <span
      aria-hidden="true"
      className={notificationDotVariants({ colorVariant, placement, size })}
      {...props}
    />
  )
}
